import UserList from '../pages/users/list';
import EditUserForm from '../pages/users/edit';
import ChangeUserPasswordForm from '../pages/users/change-password';

export const USER_LIST_PATH = '/users/list/';
export const USER_ADD_PATH = '/users/add/';
export const USER_EDIT_PATH = '/users/edit/:id/';
export const USER_CHANGE_PASSWORD_PATH = '/users/:id/change-password';

export const UserRouters = [
  {
    path: USER_LIST_PATH,
    exact: true,
    component: UserList
  },
  {
    path: USER_ADD_PATH,
    exact: true,
    component: EditUserForm
  },
  {
    path: USER_EDIT_PATH,
    exact: true,
    component: EditUserForm
  },
  {
    path: USER_CHANGE_PASSWORD_PATH,
    exact: true,
    component: ChangeUserPasswordForm
  }
];
